type BrandMarkProps = {
  size?: number;
  className?: string;
  /** When true, uses ink tile background (favicon-style). Default is transparent for UI. */
  tiled?: boolean;
};

/** Geometric Anchor mark — matches public/logo-mark.svg; uses currentColor for the shank. */
export function BrandMark({ size = 24, className = '', tiled = false }: BrandMarkProps) {
  if (tiled) {
    return (
      <svg
        className={`brand-mark ${className}`.trim()}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        aria-hidden="true"
      >
        <rect width="32" height="32" rx="6" fill="#0d1117" />
        <circle cx="16" cy="8.5" r="2.75" stroke="#1f4fd8" strokeWidth="1.75" />
        <path
          d="M16 11.5V24.5M16 24.5c-4.2 0-7.5-2.2-7.5-2.2M16 24.5c4.2 0 7.5-2.2 7.5-2.2M8.5 16H11M21 16h2.5"
          stroke="#e7ebf1"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg
      className={`brand-mark ${className}`.trim()}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      aria-hidden="true"
    >
      <circle cx="32" cy="16" r="6" stroke="#1f4fd8" strokeWidth="3.5" />
      <path
        d="M32 23V52M32 52c-9.5 0-17-5-17-5M32 52c9.5 0 17-5 17-5M15 34H21M43 34h6"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
